import { findRule } from '../Utils'

const validate = vObj => {

  //console.log(vObj)
  let errorBag = vObj.errorBag
  let params = findRule(errorBag, 'same_as').ruleParams.split(',')

  let value = vObj.value
  //console.log(value)
  let requiredField = params[0]
  //console.log(requiredField)
  let requiredFieldVal = vObj.vnode.context[requiredField]
  //console.log(requiredFieldVal)
  var otherField = vObj.vnode.context.$validator.find(
    v => v.compId === requiredField
  )
  //console.log(otherField)
  let required = value === otherField.value

  return required
}

export { validate }

export default {
  validate
}
